import React from "react";

export const ModalScreen = ({ children, close }) => {
  const onClose = ({ target }) => {
    if (target.id === "modal-screen-center-finanzas-dash") {
      close(false);
    }
  };
  return (
    <div id="modal-screen-center-finanzas-dash" onClick={(e) => onClose(e)}>
      {children}
    </div>
  );
};